import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import Title from '../../components/title';
import styles from './about.module.css';

const CoWorkers = () => {
    const [breadCrumbItems, setBreadCrumbItems] = useState([]);
    useEffect(() => {
        setBreadCrumbItems([{ title: 'خانه', url: '/' }, { title: 'ویژه همکاران', url: '/coworker' }]);
    }, []);
    return (<>
        <Title title={'ویژه همکاران'} />
        <div className={'clearfix'}></div>
        <div className={'container'}>
            <BreadCrumb items={breadCrumbItems} />
            <div id={styles.coWorkersSpecialDownload}>
                <div className={'row'}>
                    <ul className={styles.downloads}>
                        <li className={'col-xs-12 col-md-4'}>
                            <Link to={'/retired'} className={styles.linkEl}>
                                <div className={styles.pattern}></div>
                                <span>
                                    کانون بازنشستگان
                                </span>
                            </Link>
                        </li>
                        <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://oa.isc.iranet.net/" target={'_blank'} rel="noreferrer">
                                <div className={styles.pattern}></div>
                                <span>
                                    اتوماسیون اداری
                                </span>
                            </a>
                        </li>

                        <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://mail.iranet.net" target={'_blank'} rel="noreferrer">
                                <div className={styles.pattern} />
                                <span>
                                    ایمیل سازمانی
                                </span>
                            </a>
                        </li>
                        {/* <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://www.isc.co.ir/portal/File/ShowFile.aspx?Object=File&ID=c7969c21-7ab0-48f8-aca0-8b35a5ae8bad" rel="noreferrer" target={'_blank'}>
                                <div className={styles.pattern} />
                                <span>
                                    برنامه Foxit جهت نمایش PDF
                                </span>
                            </a>
                        </li>
                        <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://www.isc.co.ir/portal/File/ShowFile.aspx?Object=File&ID=13e232a5-5814-40d6-b776-28d6b88e712c" rel="noreferrer" target={'_blank'}>
                                <div className={styles.pattern} />
                                <span>
                                    فونت ها
                                </span>
                            </a>
                        </li>
                        <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://inv.isc.co.ir/Documents/Students.pdf" rel="noreferrer" target={'_blank'}>
                                <div className={styles.pattern} />
                                <span>
                                    دانلود فایل تصاویر دانش آموزان نمونه (PDF)
                                </span>
                            </a>
                        </li>
                        <li className={'col-xs-12 col-md-4 pull-right'}>
                            <a href="https://inv.isc.co.ir/Documents/Students.swf" rel="noreferrer" target={'_blank'}>
                                <div className={styles.pattern} />
                                <span>
                                    دانلود فایل تصاویر دانش آموزان نمونه (SWF)
                                </span>
                            </a>
                        </li> */}

                    </ul>
                </div>
                <div className={'clearfix'}></div>
            </div>
        </div>
    </>);
}

export default CoWorkers;